import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import ReactDOM from 'react-dom';
import LoadingBar from 'react-top-loading-bar';
import { mutate } from 'swr';
import { AppRouteUi, PaginationSettings, PlatformType } from '../../configs';
import { AdminPageTemplate, Searchbar } from "../../features";
import { ApiSchemaCreateVendorLanguage, ApiSchemaVendorLanguageData } from '../../models';
import { useFunctionalityPagedVendorLanguage, useFunctionalityVendorLanguage, useFunctionalityLanguage } from '../../pages/hooks';
import { ModalAddVendorLanguage, ModalConfirmDelete } from '../modals';
import { AssetSvg } from '../../assets';

export function VendorLanguageTab() {
  const vendorId = AppRouteUi.Vendors.Profile.useParam();
  const [loaderProgress, setLoaderProgress] = useState(0);
  const [showDeleteModal, setDeleteShowModal] = useState(false);
  const [show, setShow] = React.useState(false);
  const [pageIndex, setPageIndex] = useState(PaginationSettings.initialPageIndex);
  const [pageSize, setPageSize] = useState(PaginationSettings.initialPageSize);
  const [searchText, setSearchText] = useState<string>("");
  const [langIdToDelete, setLangIdToDelete] = useState<string>("");
  const [hasPagingData, setHasPagingData] = useState<boolean>(false);
  const { onDelete } = useFunctionalityVendorLanguage({ setDeleteModalShow: setDeleteShowModal });
  const [vendorName, setVendorName] = useState<string | null>(null);
  const [dataToEdit, setDataToEdit] = useState<ApiSchemaCreateVendorLanguage | undefined>(undefined);
  

  const { pagedVendorLanguageList, pagedVendorLanguageListCount, pagedVendorLanguageUrl } = useFunctionalityPagedVendorLanguage(
    {
      pageSize,
      pageNo: pageIndex,
      searchText: searchText?.trimStart(),
      setLoaderProgress
    }
  );

  const { languageList, isLoading } = useFunctionalityLanguage({ plaformType: PlatformType.OPI, shouldLanguageGetAllInvoke: true });

  const languageIdToName = React.useMemo(() => {
    const map = new Map<string, string>();
    (languageList ?? []).forEach(opt => {
      if (opt?.value) map.set(String(opt.value), String(opt.label ?? ""));
    });
    return map;
  }, [languageList]);

  useEffect(() => {
    if (pagedVendorLanguageListCount) {
      setHasPagingData(true);
    } else {
      setHasPagingData(false);
    }
  }, [pagedVendorLanguageList, pagedVendorLanguageList, languageList]);
  const handleSearch = (e: any) => {
    ReactDOM.unstable_batchedUpdates(() => {
      setSearchText(e.target.value);
      setPageIndex(1);
    });
  };
  const onChangePageIndex = (index: number) => {
    setPageIndex(index);
  };
  const onChangePageSize = (size: number) => {
    setPageSize(size);
  };
  const vendorsLanguageTableColumns = [
    {
      name: "Language",
      selector: (row: ApiSchemaVendorLanguageData) =>
        languageIdToName.get(String(row.languageId)) ??
        (isLoading ? "Loading…" : "—"),
    },
    {
      name: 'Vendor Language Name',
      selector: (row: ApiSchemaVendorLanguageData) => row.name,
    },
    {
      name: 'Code',
      selector: (row: ApiSchemaVendorLanguageData) => row.code,
    },
    {
      name: 'Actions',
      allowOverflow: true,
      selector: (row: ApiSchemaVendorLanguageData) => {
        return (
          <>
            <div
              className="btn svg-color"
              style={{ paddingLeft: "0px", paddingRight: "5px" }}
              title="Edit"
              onClick={() => {
                const selectedRow = row;
                setDataToEdit(selectedRow);
                setShow?.(true);
              }}
            >
              <span >
                <AssetSvg.Edit />
              </span>
            </div>
            <button
              className="btn btn-link svg-color py-0 "
              onClick={() => {
                setDeleteShowModal(true); setLangIdToDelete(row.id); setVendorName(row.name)
              }}
            >
              <span >
                <AssetSvg.Delete />
              </span>
            </button>
          </>
        );
      },
    },
  ]
  const deleteHandler = () => {
    if (langIdToDelete) {
      onDelete(langIdToDelete)
        .then(() => {
          setDeleteShowModal(false);
          mutate(pagedVendorLanguageUrl)
        })
        .catch((e) => console.error(e));
    }
  };
  return (
    <>
      <LoadingBar
        progress={loaderProgress}
        onLoaderFinished={() => setLoaderProgress(0)}
      />
      <div className="col-12 my-3 px-3">
        <button
          className="btn btn-primary text-uppercase"
          onClick={() => {
            setDataToEdit?.(undefined);
            setShow(true);
          }}
        >
          <i className="s7 s7-plus"></i>  Add Language
        </button>
      </div>

      <div className="px-3 pb-3">
        <AdminPageTemplate
          pagingKey={`VendorLanguageTab:${vendorId}`}
          loaderProgress={loaderProgress}
          // pageTitle="Vendor"
          // modalControlBtnLabel="Create Vendor"
          tableHeaders={vendorsLanguageTableColumns}
          tableData={pagedVendorLanguageList || []}
          //setCreateModalShow={setCreateModalShow}
          searchText={searchText}
          handleSearch={handleSearch}
          pageIndex={pageIndex}
          setPageIndex={setPageIndex}
          pageSize={pageSize}
          count={pagedVendorLanguageListCount}
          onChangePageIndex={onChangePageIndex}
          onChangePageSize={onChangePageSize}
          hasPagingData={hasPagingData}
          setHasPagingData={setHasPagingData}
        />
      </div>
      {
        show && <ModalAddVendorLanguage
          show={show}
          handleShow={setShow}
          pagedVendorLanguageUrl={pagedVendorLanguageUrl}
          languageList = {languageList}
          isLoadingLangList = {isLoading}
          dataToEdit={dataToEdit}
        />
      }
      {
        showDeleteModal && <ModalConfirmDelete
          show={showDeleteModal}
          handleShow={setDeleteShowModal}
          deleteHandler={deleteHandler}
          itemName={vendorName}
        />
      }
    </>
  )
}
